import { useState, useContext, useEffect, useRef } from "react"
import { CSelect, BtnLoader, toast } from "../../../components/widget"
import { ContextNav, ContextLoading, ContextDashboard } from "../../../context";
import { DatePicker } from "jalali-react-datepicker";
import { useNavigate, useParams } from "react-router-dom";
import { EditRollCallApi, GetSingleRollCallApi } from "../../../api";
import { convertDateToString, getDateNow } from "../../../utils/getDate";
import { Link } from "react-router-dom";

export const RollcallEdit = () => {
    const [userInfo, setUserInfo] = useState<any>(null);
    const [defualtDate, setDefualtDate] = useState<any>(null);
    const navigate = useNavigate()
    let params = useParams();
    const formRef: any = useRef()
    const startDateRef: any = useRef()
    const endDateRef: any = useRef()
    const CtxNav = useContext(ContextNav)
    const CtxDash = useContext(ContextDashboard)
    const CtxLoad = useContext(ContextLoading)

    const onChangeValueDate = (e: any, type: string) => {
        let data = { ...defualtDate };
        data[type] = convertDateToString(e.value._i.slice(0, 10));
        data[`${type}_date`] = e.value._i.slice(0, 10);
        setDefualtDate(data)
    }

    const onFinishEdit = async (e: any) => {
        e.preventDefault()
        CtxLoad.setDisplayLoadingBtn(true)
        let res = await EditRollCallApi(formRef, defualtDate, userInfo)
        CtxLoad.setDisplayLoadingBtn(false)
        if (res.success) {
            toast(res.message, { type: "success" })
            navigate('/p/reports/rollcall');
        }
        else {
            toast(res.message, { type: "error" })
        }
    }

    const getData = async () => {
        let res = await GetSingleRollCallApi(params.id)
        if (res.success) {
            setUserInfo(res.data)
            formRef.current['start_hours'].value =(res?.data?.entrance && res?.data?.entrance != null) ? res.data.entrance.slice(11, 13) : '00';
            formRef.current['start_min'].value =(res?.data?.entrance && res?.data?.entrance != null) ? res.data.entrance.slice(14, 16) : '00';
            formRef.current['end_hours'].value =(res.data.exit && res.data.exit != null) ? res.data.exit.slice(11, 13) : '00';
            formRef.current['end_min'].value =(res.data.exit && res.data.exit != null) ? res.data.exit.slice(14, 16) : '00';
            setDefualtDate({
                'start':(res?.data?.entrance && res?.data?.entrance != null) ? convertDateToString(res?.data?.entrance.slice(0, 10)) : convertDateToString(getDateNow()),
                'start_date':(res?.data?.entrance && res?.data?.entrance != null) ? res?.data?.entrance.slice(0, 10) : getDateNow(),
                'end':(res?.data?.exit && res?.data?.exit != null) ? convertDateToString(res?.data?.exit.slice(0, 10)) : convertDateToString(getDateNow()),
                'end_date':(res?.data?.exit && res?.data?.exit != null) ? res?.data?.exit?.slice(0, 10) : getDateNow(),
            })
            
            
        }
    }

    useEffect(() => {
        document.title = "ویرایش تردد | دایان"
        CtxNav.setActiveMenuItem({ 'item': 1, 'subItem': 0, })
        getData()
    }, [])

    return (
        <>
            <div className=" w-full flex flex-col">
                <h1 className="sm:text-2xl text-lg font-bold mb-[30px]">ویرایش تردد </h1>

                <form ref={formRef} onSubmit={onFinishEdit} className=" w-full  flex flex-col shadow sm:rounded-xl rounded-lg bg-white py-[15px] sm:py-[30px] sm:px-[20px] px-[10px]">

                    <div className="md:w-10/12 w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                        <div className=" w-full md:w-2/12 h-[50px] flex items-center md:mb-0 mb-1">
                            <svg x="0px" y="0px" viewBox={'0 0 24 24'} className={`  h-5 'fill-dayan-gray-100' `}>
                                <use xlinkHref="/assetes/svg/exit.svg#exit" />
                            </svg>
                            <span className="text-[11px] mr-3">تاریخ و ساعت ورود </span>
                        </div>
                        <div className=" w-full md:w-10/12  flex flex-col sm:flex-row items-center">
                            <div className=" w-full sm:w-[50%] h-[50px] flex  items-center pl-0 sm:pl-2">
                                <div className=" w-[50%] h-full pl-1">
                                    <CSelect name="start_hours" placeholder={'ساعت'} title="ساعت" border={true} required={true}>
                                        {['00','01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'].map((item: any, index: number) =>
                                            <option key={index} value={item}>{item}</option>
                                        )}
                                    </CSelect>
                                </div>
                                <div className=" w-[50%] h-full pr-1">
                                    <CSelect name="start_min" placeholder={'دقیقه'} title="دقیقه" border={true} required={true}>
                                        {['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'].map((item: any, index: number) =>
                                            <option key={index} value={item}>{item}</option>
                                        )}
                                    </CSelect>
                                </div>
                            </div>
                            <div className=" w-full sm:w-[50%] h-[50px] sm:mt-0 mt-5 pr-0 sm:pr-2">
                                <div className={` flex relative px-[7px] h-full rounded-[5px] items-center mb-[3px] border border-dayan-gray-100`}>
                                    <span className="text-[12px] text-dayan-gray-100 absolute bg-white top-[-12px] right-[15px] px-[10px]">تاریخ ورود</span>
                                    <div className={` jalali-datePicker flex items-center justify-center w-full h-full bg-transparent px-[10px] sm:text-[13px] text-[11px]`} >
                                        {defualtDate != null &&
                                            <>
                                                {/* @ts-ignore */}
                                                < DatePicker ref={startDateRef} timePicker={false} onClickSubmitButton={(e: any) => { onChangeValueDate(e, 'start') }} value={defualtDate.start} />
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="md:w-10/12 w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px]  pb-[15px] sm:pb-[30px]">
                        <div className=" w-full md:w-2/12 h-[50px] flex items-center md:mb-0 mb-1">
                            <svg x="0px" y="0px" viewBox={'0 0 24 24'} className={`  h-5 'fill-dayan-gray-100' `}>
                                <use xlinkHref="/assetes/svg/exit.svg#exit" />
                            </svg>
                            <span className="text-[11px] mr-3">تاریخ و ساعت خروج </span>
                        </div>
                        <div className=" w-full md:w-10/12  flex flex-col sm:flex-row items-center">
                            <div className=" w-full sm:w-[50%] h-[50px] flex  items-center pl-0 sm:pl-2">
                                <div className=" w-[50%] h-full pl-1">
                                    <CSelect name="end_hours" placeholder={'ساعت'} title="ساعت" border={true} >
                                        {['00','01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'].map((item: any, index: number) =>
                                            <option key={index} value={item}>{item}</option>
                                        )}
                                    </CSelect>
                                </div>
                                <div className=" w-[50%] h-full pr-1">
                                    <CSelect name="end_min" placeholder={'دقیقه'} title="دقیقه" border={true} >
                                        {['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'].map((item: any, index: number) =>
                                            <option key={index} value={item}>{item}</option>
                                        )}
                                    </CSelect>
                                </div>
                            </div>
                            <div className=" w-full sm:w-[50%] h-[50px] sm:mt-0 mt-5 pr-0 sm:pr-2">
                                <div className={` flex relative px-[7px] h-full rounded-[5px] items-center mb-[3px] border border-dayan-gray-100`}>
                                    <span className="text-[12px] text-dayan-gray-100 absolute bg-white top-[-12px] right-[15px] px-[10px]">تاریخ خروج</span>
                                    <div className={` jalali-datePicker flex items-center justify-center w-full h-full bg-transparent px-[10px] sm:text-[13px] text-[11px]`} >
                                        {defualtDate != null &&
                                            <>
                                                {/* @ts-ignore */}
                                                < DatePicker ref={endDateRef} timePicker={false} onClickSubmitButton={(e: any) => { onChangeValueDate(e, 'end') }} value={defualtDate.end} />
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className=" w-full mt-[40px] flex items-center">
                        {CtxLoad.displayLoadingBtn ?
                            <button type="button" className="w-[100px] h-[40px] bg-dayan-gray-200 text-white rounded-[5px] text-sm shadow cursor-not-allowed relative flex justify-center items-center"><BtnLoader /></button>
                            :
                            <button type="submit" className="w-[100px] h-[40px] bg-dayan-gray-200 text-white rounded-[5px] text-sm shadow">اعمال</button>
                        }
                        <Link to='/p/reports/rollcall'>
                            <button type="button" className="w-[100px] h-[40px] bg-[#a4a4a4] text-dayan-gray-200 rounded-[5px] mr-3 text-sm shadow">بازگشت</button>
                        </Link>
                    </div>

                </form>

            </div>

        </>
    )
}